/**
 * Returns a value indicating whether the site is iframed by Exact Studio.
 *
 * Not working in Firefox as it doesn't support document.location.ancestorOrigins.
 * However, Firefox is not supported.
 */
export const isIframedByExactStudio = () => {
  return [...(document.location.ancestorOrigins ?? [])]
    .map((x) => new URL(x).hostname.toLowerCase().trim())
    .includes('www.exactstudio.com');
};
